// extracted by mini-css-extract-plugin
export default {"HeroCircle":"HeroCircle_HeroCircle__ljVl6"};